import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { TimelineMax, TweenMax, Expo } from 'gsap';

import Background from '../Background';
import PartnershipLogo from '../PartnershipLogo';
import CTA from '../CTA';

import { updateView, showAbout as dispatchShowAbout } from '../../actions';
import { track } from '../../utils/analytics';
import { processLines } from '../../utils/string';

import style from './index.module.scss';

class Splash extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      transition: 'in'
    }

    this.showAbout = this.showAbout.bind(this);
    this.animateIn = this.animateIn.bind(this);
    this.animateOut = this.animateOut.bind(this);
    this.handleReverseComplete = this.handleReverseComplete.bind(this);
    this.handleAnimationComplete = this.handleAnimationComplete.bind(this);
  }

  handleReverseComplete() {
    const { dispatch } = this.props;

    // setTimeout(() => {
      // TweenMax.set(this.container, { autoAlpha: 0 });
      this.done.call(this);
      dispatch(updateView('quiz'));
    // }, 200);
  }

  handleAnimationComplete() {
    this.done.call(this);
  }

  animateIn() {
    TweenMax.set(this.container, { autoAlpha: 1 });
    // this.tl.timeScale(1);
    this.tl.delay(0);
    this.tl.play();
  }

  animateOut(e) {
    if (e) track('clicked', 'start quiz');

    // this.tl.timeScale(0.5);
    this.tl.delay(0);
    this.tl.reverse();
  }

  showAbout() {
    const { dispatch } = this.props;
    dispatch(dispatchShowAbout(true));
  }

  hideAbout() {
    const { dispatch } = this.props;
    dispatch(dispatchShowAbout(false));
  }

  componentDidMount() {
    const bg = this.container.querySelectorAll(`.${style['background-image']}`);
    const logo = this.container.querySelectorAll(`.${style.logo}`);
    const title = this.lockup.querySelector(`.${style.title}`);
    const description = this.lockup.querySelectorAll(`.${style.description}`);
    const cta = this.lockup.querySelector(`.${style.cta}`);
    this.tl = new TimelineMax({ paused: true, delay: 0, onReverseComplete: this.handleReverseComplete, onComplete: this.handleAnimationComplete });
    this.tl.staggerFromTo([...logo, title, ...description, cta], 1.5, { opacity: 0 }, { opacity: 1, ease: Expo.easeOut }, 0.05);
    TweenMax.to(bg, 1.5, { opacity: 1 });

    track('visible', 'intro');
  }
  
  render() {
    const { view: { id }, themes, base: { app: { about: { visible }, introSiteTitle, introSiteSubtitle, ctaText, ctaBackgroundColor, titleColor } }, layout: { mobile } } = this.props;
    const { active } = this.state;
    const show = id === 'splash';
    const { questionBackground, textColor } = themes[0];

    const title = introSiteTitle;//mobile ? introSiteTitleMobile : introSiteTitle;

    return (
      <Transition
        timeout={0}
        in={show}
        onEnter={() => this.setState(() => ({ active: true }))}
        addEndListener={(node, done) => {
          this.done = done;
          show ? setTimeout(() => this.animateIn(), 700) : this.animateOut();
        }}
      >
        <div className={`${style.splash} view ${active ? 'active' : ''} ${visible ? style.about : ''}`}
          style={{ display: active ? 'flex' : 'none', color: textColor }} ref={instance => this.container = instance}>
          {/* <img src="./splash.png" style={{ width: '100%', height: 'auto', position: 'absolute', top: 0, left: 0 }} /> */}
          <Background show={active}
            image={`${questionBackground.replace('{{platform}}', mobile ? 'mobile' : 'desktop')}`} />
          <div className={style.lockup} ref={instance => this.lockup = instance}>
            <div className={style.main}>
              <div className={style.title} style={{ color: titleColor }}>{processLines(title).map((line, index) => <div key={`line-${index}`}>{line}</div>)}</div>
              <div className={`${style['description']}`}>{processLines(introSiteSubtitle).map((line, index) => <div key={`line-${index}`}>{line}</div>)}</div>
              <CTA text={ctaText} primaryColor={textColor} secondaryColor={ctaBackgroundColor} className={style.cta} show={show} onClick={this.animateOut} delay={2.5} />
            </div>
            <PartnershipLogo show={show} animate={true} color={titleColor} onClick={this.showAbout} className={`${style.logo}`} />
          </div>
        </div>
      </Transition>
    );
  }
}

const mapStateToProps = state => ({
  view: state.view,
  base: state.base,
  themes: state.themes,
  layout: state.layout
});

export default connect(mapStateToProps)(Splash);
